import { render, staticRenderFns } from "./KAMReadOnlyForm.vue?vue&type=template&id=08ee2459&scoped=true"
import script from "./KAMReadOnlyForm.vue?vue&type=script&lang=ts"
export * from "./KAMReadOnlyForm.vue?vue&type=script&lang=ts"
import style0 from "./KAMReadOnlyForm.vue?vue&type=style&index=0&id=08ee2459&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ee2459",
  null
  
)

export default component.exports